import { Form, Menu } from "semantic-ui-react";

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRange } from "react-instantsearch";

import DateInput from "../DateInput/DateInput";

export default function InstantSearchRefinementDateRange({ attribute }) {
	const { t } = useTranslation();

	const { refine, canRefine, start, range } = useRange({ attribute });

	const [from, to] = start;

	const [selectedStartDate, setSelectedStartDate] = useState(null);
	const [selectedEndDate, setSelectedEndDate] = useState(null);

	// Clear local state when refinements change externally (e.g. clear button)
	useEffect(() => {
		setSelectedStartDate(null);
		setSelectedEndDate(null);
	}, [from, to]);

	const startDate = selectedStartDate || (from > -Infinity ? new Date(from * 1000) : null);
	const endDate = selectedEndDate || (to < Infinity ? new Date(to * 1000) : null);

	return (
		<>
			<Menu.Item>
				<Form>
					<DateInput
						value={startDate}
						disabled={!canRefine}
						placeholder={t("fromDate", "From date")}
						selectsStart
						startDate={startDate}
						endDate={endDate}
						onChange={(e, { value }) => {
							setSelectedStartDate(value instanceof Date ? value : null);

							const fromValue = value instanceof Date ? value.getTime() / 1000 : undefined;

							refine([
								fromValue !== undefined && range?.min !== undefined
									? Math.max(fromValue, range.min)
									: fromValue,
								to < Infinity ? to : undefined,
							]);
						}}
						style={{ zIndex: 1 }}
					/>
				</Form>
			</Menu.Item>

			<Menu.Item>
				<Form>
					<DateInput
						value={endDate}
						disabled={!canRefine}
						placeholder={t("toDate", "To date")}
						selectsEnd
						startDate={startDate}
						endDate={endDate}
						onChange={(e, { value }) => {
							if (value instanceof Date) {
								value.setHours(23, 59, 59, 0);
							}

							setSelectedEndDate(value instanceof Date ? value : null);

							const toValue = value instanceof Date ? value.getTime() / 1000 : undefined;

							refine([
								from > -Infinity ? from : undefined,
								toValue !== undefined && range?.max !== undefined
									? Math.min(toValue, range.max)
									: toValue,
							]);
						}}
						style={{ zIndex: 1 }}
					/>
				</Form>
			</Menu.Item>
		</>
	);
}
